export class MediaGallery {
	constructor(element: HTMLElement) {
		const thumbnails = element?.querySelectorAll('.thumbnails li');
		const mainImage = element?.querySelector('.image img') as HTMLImageElement;

		thumbnails?.forEach(thumbnail => {
			thumbnail.addEventListener('click',
				(e) => {
					e.preventDefault();
					let li = e.target as HTMLElement;

					if (li.nodeName === "IMG") {
						li = li.closest('li');
					}
					const fullImage = li.dataset.full;
					
					mainImage.src = fullImage;
				});

		});
		
	}


}